/* eslint-disable no-console */
import { addToEpiCart } from './utils/cart-utils';
import { addOutdoorProductToOrderLine } from './utils/sst-utils';
import { getMiniCartHtml } from './modules/mini-cart';
import { validate } from './utils/form-validation-utils';
import SiteToaster from './modules/site-toaster';

export default class ProductAddToCart {
  constructor() {
    this.addToCarBtn = document.querySelector('.add-to-cart-btn');
    this.styleSelector = document.getElementById('Style');
    this.selectedOptionPrice = document.getElementById('selectedOptionPrice');
    this.toaster = null;
    this.init();
  }

  getFirstOptionWithValue() {
    const selector = this.styleSelector;
    if (selector) {
      const optionList = selector.querySelectorAll('option');
      if (optionList.length > 2) {
        return optionList[1];
      }
    }
    return '';
  }

  init() {
    let variantCode = '';
    const btn = this.addToCarBtn;
    const selector = this.styleSelector;
    const price = this.selectedOptionPrice;
    const getPrice = (str) => {
      const matches = str.match(/\(([^\)]+)\)/); /* eslint-disable-line no-useless-escape */
      if (matches === null) {
        return '';
      }
      if (matches.length > 1) {
        return matches[1];
      }
      return '';
    };

    if (selector && price) {
      // Set default price that's displayed
      const option = this.getFirstOptionWithValue();
      if (option !== '') {
        price.textContent = getPrice(option.textContent);
      }
      // Update on-page price
      selector.addEventListener('change', () => {
        if (selector.value === '') {
          const optionList = selector.querySelectorAll('option');
          price.textContent = getPrice(optionList[1].textContent);
        } else {
          const selected = selector.querySelector(`option[value="${selector.value}"]`);
          if (selected) {
            price.textContent = getPrice(selected.textContent);
          }
        }
      });
    }

    if (btn) {
      btn.addEventListener('click', () => {
        // Code selection and validation
        let groupId = '';
        if (btn && selector) {
          // Make sure item is selected
          const form = document.querySelector('.add-to-cart-form');
          if (!validate(form)) {
            return;
          }
          variantCode = selector.value;
          const option = this.getFirstOptionWithValue();
          if (option !== '') {
            groupId = option.value;
          }
        } else if (btn && selector === null) {
          variantCode = btn.getAttribute('data-variant-id');
        }
        // Update button status and add to cart
        btn.classList.add('updating');
        btn.setAttribute('disabled', 'disabled');
        addOutdoorProductToOrderLine(variantCode, groupId)
          .then(addToEpiCart(variantCode))
          .then(() => {
            getMiniCartHtml();
            btn.classList.remove('updating');
            btn.removeAttribute('disabled');
            if (this.toaster) {
              this.toaster.remove();
            }
            this.toaster = new SiteToaster({
              id: 'status-toaster',
              message: '<strong>Item has been added to your cart.</strong>',
            });
            this.toaster.open();
            setTimeout(() => {
              this.toaster.close();
            }, 3000);
            setTimeout(() => {
              this.toaster.remove();
            }, 3300);
          });
      });
    }
  }
}
window.ProductAddToCart = ProductAddToCart;
/* eslint-enable no-console */
